import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  BrowserRouter,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import PublicLayout from "layouts/Public";
import GoogleAnalytics from "./analytics/GoogleAnalytics";

const langToSegment = (code) =>
  (code || "").split("-")[0].toLowerCase();

const getLangCode = (lang) => {
  if (!lang) return null;

  if (typeof lang === "string") {
    return lang;
  }

  if (
    typeof lang === "object" &&
    typeof lang.code === "string" &&
    lang.code.trim()
  ) {
    return lang.code;
  }

  return null;
};

const App = ({ account, staticData }) => {
  const languages = staticData?.languages || [];

  const accountLangCode = getLangCode(account?.language);

  const defaultLangCode =
    accountLangCode ||
    languages.find((l) => l.isDefault)?.code ||
    "mk-MK";

  const defaultSegment = langToSegment(defaultLangCode);

  const isValidLangSegment = (segment) =>
    languages.some(
      (l) => langToSegment(l.code) === segment
    );

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--brand-color",
      process.env.REACT_APP_BRAND_COLOR || "#f5593d"
    );

    document.documentElement.style.setProperty(
      "--header-menu-gap",
      process.env.REACT_APP_HEADER_MENU_GAP || "0"
    );

    document.title =
      staticData?.channel?.localizedTerms?.find(
        (x) =>
          x.languageId ===
          languages.find(
            (l) => l.code === defaultLangCode
          )?.languageId
      )?.name || "SEI Net";
  }, [staticData, languages, defaultLangCode]);

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <GoogleAnalytics />

      <Switch>
        <Route
          path="/Default.aspx"
          render={() =>
            (window.location.href = `${process.env.PUBLIC_URL}/`)
          }
        />

        <Route
          path="/wcf/*"
          render={() =>
            (window.location.href = `${process.env.PUBLIC_URL}/wcf`)
          }
        />

        <Route
          path="/FileServer.aspx/*"
          render={() =>
            (window.location.href = `${process.env.PUBLIC_URL}/FileServer.aspx`)
          }
        />

        <Route
          exact
          path="/"
          render={() => (
            <Redirect to={`/${defaultSegment}`} />
          )}
        />

        <Route
          path="/:lang"
          render={(props) => {
            const urlLang = (
              props.match.params.lang || ""
            ).toLowerCase();

            if (!languages.length) {
              return null;
            }

            if (!isValidLangSegment(urlLang)) {
              const rest =
                props.location.pathname.replace(
                  /^\/[^/]+/,
                  ""
                );

              return (
                <Redirect
                  to={`/${defaultSegment}${rest}${props.location.search}${props.location.hash}`}
                />
              );
            }

            return <PublicLayout {...props} />;
          }}
        />
      </Switch>
    </BrowserRouter>
  );
};

function mapStateToProps(state) {
  const { account, staticData } = state;

  return {
    account,
    staticData,
  };
}

export default connect(mapStateToProps)(App);